import { CUCounter } from './cu-counter-model';

export var cuCounter = new CUCounter({ id: 'cuCounter' });
